import api from './AxiosInstance';

export class SpecialitesService {
  getAllSpecialites = async () => {
    try {
      const response = await api.get(`/Specialites/list`, {
      
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; // Vous pouvez relancer l'erreur pour la gérer à un niveau supérieur si nécessaire
    }
  };


  addSpecialite = async ( newPrestation) => {
    try {
      
  
      const response = await api.post(`/Specialites/add`, newPrestation);
      
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  AddActe  = async (codespe) => {
    try {
      const response = await api.get(`/LignePrestations/Actes/list/${codespe}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };
  
  updateSpecialites = async ( updatedPrestation) => {
    try {
     

      const response = await api.put(`/Specialites/update`, updatedPrestation);

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de prestation :', error);
      throw error;
    }
  };

  deleteSpecialites = async ( prestationId) => {
    try {
     

      const response = await api.delete(`/Specialites/delete/${prestationId}`);

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de prestation :', error);
      throw error;
    }
  };
}